













































































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import Trigger from '@modules/ui/triggers/Trigger'
import ResourceList from '@modules/ui/List/ResourceList'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'ActivationResourceList'
  components: {
    Modal,
    Trigger,
    ResourceList,
    LoadingIndicator
  }

  vue:
    props: ['activations', 'actions', 'filtersOverriden', 'infiniteWrapper', 'options']

    data: ->
      sortList: [
        { field: 'created_at', value: 'Created At' }
        { field: 'accepted_at', value: 'Accepted At' }
      ]
      sortValue: ''

      filters:
        sort: []
        q: ''

      pageNumber: 1
      selectedActivations: []
      selectedFilters: []

      deleteModal:
        modalOptions:
          title: 'Delete Activation'
          button:
            label: 'Delete'
            type: 'danger'

    mounted: ->
      @filters = @filtersOverriden if @filtersOverriden?

    computed:
      components: ->
        {
          'activation-resource-list-item': () => import('./ActivationResourceListItem')
        }
      title: ->
        @options?.title || 'Activations'

      resourceKey: ->
        @options?.resourceKey || 'activations'

      availableSort: ->
        ctx = this
        availableList = @sortList.filter((sort) ->
          item = ctx.filters.sort.find((item) -> item.field == sort.field)
          !item
        )
        availableList

      deleteTriggerResource: ->
        { key: @resourceKey, triggerName: 'delete', component: @$parent.$parent }
      deleteTriggerPayload: ->
        payload =
          activation_ids: @selectedActivations.map((e) -> e.id)
        payload

    methods:
      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, @filters, { page: @pageNumber })
        @pageNumber += 1

      hiFilterChange: (selectedFilters) ->
        @$refs.infiniteLoading.stateChanger.reset()
        @selectedFilters = selectedFilters if selectedFilters
        @pageNumber = 1
        @actions.fetchResource(null, @resourceKey, @filters, { page: @pageNumber })
        @pageNumber += 1

      hiClearFilter: ->
        cleared_filter_scope = @filters.scopes
        Object.keys(cleared_filter_scope).forEach((key) -> cleared_filter_scope[key] = null)
        @filters.scopes = cleared_filter_scope
        @hiFilterChange()

      hiSearchChange: (q = '') ->
        @filters.q = q
        @hiFilterChange()

      hiAddSort: (order) ->
        return false if !@sortValue.length
        @filters.sort.push({ field: @sortValue, order })
        @hiFilterChange()
        @sortValue = ''

      hiRemoveSort: (sort) ->
        @filters.sort = @filters.sort.filter((item) -> item.field != sort.field)
        @hiFilterChange()

      hiFlipOrder: (sort) ->
        flippedOrder = if sort.order == 'asc' then 'desc' else 'asc'
        @filters.sort = @filters.sort.filter((item) ->
          item.order = flippedOrder if item.field == sort.field
          item
        )
        @hiFilterChange()

      sortOrderIcon: (order) ->
        if order == 'asc'
          return 'fa-arrow-up'

        return 'fa-arrow-down'

export default VueOptions.vue settings
